import React from "react";
import { Card, CheckLabel, LongTextLabel, Section, TooltipIcon, } from "@sscs/ui";
import { convertScanCheckLabel, transformPerformedChecks, } from "../../../utils";
import styles from "./performedChecks.module.scss";
const CheckRow = ({ check, isLevelCustomized, renderCheckLink, }) => {
    const convertedStatus = convertScanCheckLabel(check.label);
    return (React.createElement("div", { className: styles["check-row"] },
        React.createElement(CheckLabel, { status: convertedStatus.status, scanLevel: convertedStatus.scanLevel, isDiffCheck: convertedStatus.isDiff, isLevelCustomized: isLevelCustomized, isReproducibilityCheck: convertedStatus.isRepro }),
        React.createElement("div", { className: styles["check-name"] },
            React.createElement(LongTextLabel, { label: check.description })),
        renderCheckLink ? renderCheckLink(check) : null));
};
const PerformedChecks = ({ scans, shouldLinkToAnotherReport = false, selectedScan, requestedDiff, renderCheckLink, diffId, }) => {
    var _a;
    var _b;
    const checks = transformPerformedChecks({
        scans,
        shouldLinkToAnotherReport,
        requestedDiff,
        selectedScan,
        diffId,
    });
    const isLevelCustomized = (_b = (_a = scans[selectedScan]) === null || _a === void 0 ? void 0 : _a.inhibitors.customized) !== null && _b !== void 0 ? _b : false;
    const passed = checks.filter((check) => convertScanCheckLabel(check.label).status === "pass").length;
    const failed = checks.filter((check) => convertScanCheckLabel(check.label).status === "fail").length;
    const versionChecks = checks.filter((check) => !check.checkType.startsWith("REPRO"));
    const reproChecks = checks.filter((check) => check.checkType.startsWith("REPRO"));
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, { details: [
                passed > 0 && `${passed} passed`,
                failed > 0 && `${failed} failed`,
                React.createElement(TooltipIcon, { key: "tooltip", size: "xs", title: React.createElement(React.Fragment, null, "List of performed checks. Includes software package analysis, differential version analysis, and reproducible build verification.") }),
            ] }, "Performed checks"),
        React.createElement(Card.Content, { className: styles.content },
            React.createElement(Section, null,
                React.createElement(Section.Title, { as: "h3" }, "Version"),
                React.createElement(Section.Content, null, versionChecks.map((check) => (React.createElement(CheckRow, { key: `${check.checkType}-${check.label}-${check.description}`, check: check, isLevelCustomized: isLevelCustomized, renderCheckLink: renderCheckLink }))))),
            reproChecks.length > 0 && (React.createElement(Section, null,
                React.createElement(Section.Title, { as: "h3" }, "Reproducible build"),
                React.createElement(Section.Content, null, reproChecks.map((check) => (React.createElement(CheckRow, { key: `${check.checkType}-${check.label}-${check.description}`, check: check, isLevelCustomized: isLevelCustomized, renderCheckLink: renderCheckLink })))))))));
};
export default PerformedChecks;
//# sourceMappingURL=PerformedChecks.js.map